import { RoleEnum } from '../../utils/api';
import TransferBadge from './TransferBadge';

interface OwnProps {
    userRole?: RoleEnum;
}

export type Props = OwnProps;

export default TransferBadge;
